import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { HttpClientBase } from "./http-client-base.service"; 


export interface ImportResponse {
  processed: number;
  inserted: number;
  updated: number;
  skipped: number;
  errorsCount: number;
  errors: { row: number; field?: string; message: string }[];
}

@Injectable({ providedIn: 'root' })
export class ImportUsuariosService extends HttpClientBase {

    private endpoint = 'users';

    constructor(http: HttpClient) { 
         super(http, 'users');
    }

    get headers() {
        return {
            headers: {
            }
        }
    }
     /** POST /usuarios/import  (clave "file") */
    importarUsuariosExcel(file: File) {
        const fd = new FormData();
        fd.append('file', file);             // ← clave EXACTA: "file"
        return this.post<ImportResponse>(fd, 'import'); // -> /usuarios/import
    }
}